var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st_cal{fill:#617995;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st_cal",
    d: "M11.13,3.35c0.56,0,1.01-0.45,1.01-1.01V1.29c0-0.56-0.45-1.01-1.01-1.01s-1.01,0.45-1.01,1.01v1.06 C10.12,2.9,10.58,3.35,11.13,3.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st_cal",
    d: "M14.72,2.03h-2.03v0.51c0,0.85-0.69,1.54-1.54,1.54c-0.85,0-1.54-0.69-1.54-1.54V2.03h-4.1v0.51 c0,0.85-0.69,1.54-1.54,1.54S2.44,3.39,2.44,2.54V2.03L0.38,2v12.84h1.03h12.3l1.02,0L14.72,2.03z M13.71,13.82H1.41v-8.2h12.3 L13.71,13.82L13.71,13.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st_cal",
    d: "M3.96,3.35c0.56,0,1.01-0.45,1.01-1.01V1.29c0-0.56-0.45-1.01-1.01-1.01S2.95,0.73,2.95,1.29v1.06 C2.95,2.9,3.4,3.35,3.96,3.35z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.51,
    y: 6.72,
    className: "st_cal",
    width: 1.62,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.13,
    y: 6.72,
    className: "st_cal",
    width: 1.62,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.55,
    y: 6.72,
    className: "st_cal",
    width: 1.62,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.51,
    y: 9.08,
    className: "st_cal",
    width: 1.62,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.13,
    y: 9.08,
    className: "st_cal",
    width: 1.62,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.55,
    y: 9.08,
    className: "st_cal",
    width: 1.62,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.51,
    y: 11.5,
    className: "st_cal",
    width: 1.62,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.95,
    y: 9.08,
    className: "st_cal",
    width: 1.61,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.95,
    y: 11.5,
    className: "st_cal",
    width: 1.61,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.13,
    y: 11.5,
    className: "st_cal",
    width: 1.62,
    height: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.55,
    y: 11.5,
    className: "st_cal",
    width: 1.62,
    height: 1.43
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal);
export default __webpack_public_path__ + "static/media/cal.abf1e4169704a04dc01d6c82e2e6e067.svg";
export { ForwardRef as ReactComponent };